import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button } from "antd"
import { useTranslation } from "react-i18next"
import EventBlock from "../EventBlock"
import { getEventColor, getEventBorderColor } from "pagesV2/pro/Calendar/utils"
import { MAX_VISIBLE_EVENTS } from "pagesV2/pro/Calendar/constants"
import styles from "../index.module.css"

const BookingList = ({ events, onBookingClick }) => {
  const { t } = useTranslation()
  const [visibleCount, setVisibleCount] = useState(MAX_VISIBLE_EVENTS)
  const visible = events.slice(0, visibleCount)
  const hasMore = visibleCount < events.length
  const canShowLess = visibleCount > MAX_VISIBLE_EVENTS && events.length > MAX_VISIBLE_EVENTS

  return (
    <div className={styles.listViewEventStack}>
      {events.length === 0 && (
        <span className={styles.listViewEmpty}>{t("calendar.no_bookings")}</span>
      )}
      {visible.map((ev) => (
        <EventBlock
          key={ev.id ?? (ev.title + ev.start)}
          event={ev}
          eventColor={getEventColor(ev.payment_status)}
          eventBorderColor={getEventBorderColor(ev.payment_status)}
          setIsBookingModalOpen={(open) => { if (open) onBookingClick(ev.id) }}
          setSelectedBookingId={() => {}}
        />
      ))}
      {hasMore && (
        <Button type="link" size="small" onClick={() => setVisibleCount((c) => c + MAX_VISIBLE_EVENTS)}>
          {t("calendar.view_more")}
        </Button>
      )}
      {canShowLess && (
        <Button type="link" size="small" onClick={() => setVisibleCount(MAX_VISIBLE_EVENTS)}>
          {t("calendar.read_less")}
        </Button>
      )}
    </div>
  )
}

BookingList.propTypes = {
  events: PropTypes.array.isRequired,
  onBookingClick: PropTypes.func.isRequired,
}

export default BookingList
